import React, { createContext, useContext } from 'react';
import { notification, NotificationArgsProps } from 'antd-v6';

type NotificationApi = {
	open: (options: NotificationArgsProps) => void;
	warning: (options: NotificationArgsProps) => void;
	info: (options: NotificationArgsProps) => void;
	success: (options: NotificationArgsProps) => void;
	error: (options: NotificationArgsProps) => void;
	close: (key?: React.Key) => void;
};

const NotificationContext = createContext<NotificationApi | null>(null);

export const AppNotificationProvider = ({ children }: { children: React.ReactNode }) => {
	const [notif, contextHolder] = notification.useNotification({ top: 75 });

	const api: NotificationApi = {
		open: (options) => {
			notif.open(options);
		},
		close: (key) => {
			notif.destroy(key);
		},
		warning: (options) => {
			notif.warning(options);
		},
		info: (options) => {
			notif.info(options);
		},
		success: (options) => {
			notif.success(options);
		},
		error: (options) => {
			notif.error(options);
		},
	};

	return (
		<NotificationContext.Provider value={api}>
			{contextHolder}
			{children}
		</NotificationContext.Provider>
	);
};

export const useAppNotification = () => {
	const ctx = useContext(NotificationContext);
	if (!ctx) throw new Error('useAppNotification must be used inside AppNotificationProvider');
	return ctx;
};
